import { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import Typography from "@mui/material/Typography";

import { useFileContext } from "../context/FileWrapper";
import Button from "../shared/Button";
import { Stack } from "@mui/material";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: "12px",
  borderColor: "var(--light-grey-text)",
  borderStyle: "dashed",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  backgroundColor: "#6875880A",
  height: "258px",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const Dropzone = () => {
  const { onDrop } = useFileContext();

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      accept: {
        "image/png": [".png", ".jpg", ".jpeg"],
        "application/pdf": [".pdf"],
      },
    });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <div className="dropzone-container">
      <div
        {...getRootProps({ style })}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <input {...getInputProps()} />
        <div className="d-flex flex-column align-items-center justify-content-center">
          <img src="/assets/icons/upload-files.svg" alt="" />
          <Stack sx={{ my: "20px", textAlign: "center" }}>
            <Typography
              color="var(--text-color)"
              fontSize={18}
              fontWeight={700}
            >
              Sélectionnez un fichier ou glissez-déposez-le ici
            </Typography>
            <Typography
              color="var(--text-color)"
              fontSize={14}
              fontWeight={400}
            >
              JPG, PNG ou PDF, taille de fichier ne dépassant pas 10 Mo
            </Typography>
          </Stack>
          <Button color="primary" variant="contained">
            <Typography fontSize={14} fontWeight={400}>
              Sélectionner un fichier
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dropzone;
